// src/components/SocialLink.js
function SocialLink({ href, src, alt, width = "35px" }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <img src={src} alt={alt} style={{ width }} className="h-[35px] object-contain" />
    </a>
  );
}

export default SocialLink;